import headerFunctions from './serie-design/serie-header';
import footerFunctions from './serie-design/serie-footer';
import spotFunctions from './serie-design/serie-spots-functions';

document.addEventListener("DOMContentLoaded", () => {
    headerFunctions.init();
    footerFunctions.init();
    spotFunctions.init();

    async function getClient() {
        try {
            let response = await fetch('/conta/cliente', {
            headers: { 
                accept: 'application/json'
            }
            });
            let client = await response.json();
            let access = Object.keys(client).length > 0;
            
            // Cliente logado
            if (access) {
                document.querySelector('.header__desktop .client__login .login__modal .menu__logged').classList.add('active');
                document.querySelector('.header__desktop .client__login .login__modal .menu__login').classList.remove('active');

            } else {
                document.querySelector('.header__desktop .client__login .login__modal .menu__logged').classList.remove('active');
                document.querySelector('.header__desktop .client__login .login__modal .menu__login').classList.add('active');
            }
            
        } catch (error) { console.error(`getClient error`, error) }
    }
    getClient();
});